



































































































































































import { mixins } from 'vue-class-component'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import { Case } from '@/modules/Newcase/interfaces/case'
import S3Handler from '@/mixins/s3'
import { AccountAsset, AccountAssetType } from '@/modules/Account/interfaces/account-asset'
import AccountForm from '@/modules/Account/components/AccountForm.vue'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import { dateToDisplay } from '@/utils/dateTime'
import dollarFilter from '@/utils/dollarFilter'
import { policyStatus } from '@/modules/Policy/helpers/policy'
import RecordTypesHandler from '@/mixins/record-types'
import SearchAccount from '@/mixins/search-queries/search-account'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import AssetVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import AssetPropertyForm from '@/modules/AccountAsset/components/AssetPropertyForm.vue'
import AssetVehicleForm from '@/modules/AccountAsset/components/AssetVehicleForm.vue'
import { getAccountAssets } from '@/modules/Account/gql/account.gql'
import TextFoldingArea from './TextFoldingArea.vue'
import { showErrors } from '@/utils/snack'

@Component({
  components: {
    AccountForm,
    AssetPropertyForm,
    AssetVehicleForm,
    TextFoldingArea,
    AssetPropertyDialog,
    AssetVehicleDialog,
    AccountDialog
  }
})
export default class CasePanel extends mixins(SearchAccount, RecordTypesHandler, S3Handler) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  assets: AccountAsset[] = []
  dateToDisplay = dateToDisplay
  dollarFilter = dollarFilter
  policyStatus = policyStatus

  accountDialog = {
    actionType: 'new',
    show: false,
    title: 'New Account',
    disable: false
  }

  propertyDialog = {
    actionType: 'new',
    show: false,
    title: 'New Asset',
    disable: false
  }

  vehicleDialog = {
    actionType: 'new',
    show: false,
    title: 'New Asset',
    disable: false
  }

  get account () {
    if (!this.caseInfo) {
      return null
    }
    return this.caseInfo.account
  }

  get accountId () {
    if (!this.caseInfo) {
      return null
    }
    return +this.caseInfo.account.id
  }

  get policy () {
    if (!this.caseInfo) {
      return null
    }
    return this.caseInfo.policies[this.caseInfo.policies.length - 1] || null
  }

  get formsite () {
    const { formsite, producerForm } = this.caseInfo
    if (!formsite && !producerForm) {
      return null
    }

    if (formsite) {
      return JSON.parse(this.caseInfo.formsite)
    } else {
      const result = JSON.parse(this.caseInfo.producerForm)
      if (result.lineOfProduct.includes('Auto')) {
        delete result.content['Property Info']
      }
      if (result.lineOfProduct.includes('Home')) {
        delete result.content['Vehicle Info']
      }
      return result
    }
  }

  get formsiteName () {
    if (!this.formsite) {
      return null
    }
    const name = this.formsite.name
    if (name === 'Verge Auto / Home Quick Quote') {
      const lineOfProduct = this.formsite.lineOfProduct.toLowerCase()
      if (lineOfProduct === 'home') {
        return 'Verge Home Quick Quote From '
      }
      if (lineOfProduct === 'auto') {
        return 'Verge Personal Auto Quote From '
      }
    }
    return name + ' From '
  }

  get asset () {
    return this.caseInfo.asset
  }

  get assetLabel () {
    if (this.caseInfo.recordType.name === 'Personal Auto') {
      return 'Vehicle'
    }
    if (this.caseInfo.recordType.name === 'Homeowners') {
      return 'Property'
    }
    if (this.asset) {
      return this.asset.type === AccountAssetType.VEHICLE ? 'Vehicle' : 'Property'
    }
    return 'Property'
  }

  get property () {
    if (!this.asset) {
      return null
    }
    if (this.asset.type !== AccountAssetType.PROPERTY) {
      return null
    }
    return this.asset.property
  }

  get vehicle () {
    if (!this.asset) {
      return null
    }
    if (this.asset.type !== AccountAssetType.VEHICLE) {
      return null
    }
    return this.asset.vehicle
  }

  get totalProjectedPremium () {
    let totalNum = 0
    if (this.policy) {
      const { premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, taxesFee, brokerFee } = this.policy
      const premiumNum = premium ? Number(premium) : 0
      const agencyFeeNum = agencyFee ? Number(agencyFee) : 0
      const carrierPolicyFeeNum = carrierPolicyFee ? Number(carrierPolicyFee) : 0
      const inspectionFeeNum = inspectionFee ? Number(inspectionFee) : 0
      const stampingFeeNum = stampingFee ? Number(stampingFee) : 0
      const taxesFeeNum = taxesFee ? Number(taxesFee) : 0
      const brokerFeeNum = brokerFee ? Number(brokerFee) : 0
      totalNum = Number((premiumNum + agencyFeeNum + carrierPolicyFeeNum + inspectionFeeNum + stampingFeeNum + taxesFeeNum + brokerFeeNum).toFixed(2))
    }
    return totalNum
  }

  get accountName () {
    return this.account ? this.account.name : null
  }

  handleFileDownload (file: any) {
    this.downloadFile(file)
  }

  hidePropertyEditDialog () {
    this.propertyDialog = {
      actionType: 'new',
      show: false,
      title: 'New Property',
      disable: false
    }
  }

  hideVehicleEditDialog () {
    this.vehicleDialog = {
      actionType: 'new',
      show: false,
      title: 'New Vehicle',
      disable: false
    }
  }

  hideAcctEditDialog () {
    this.accountDialog = {
      actionType: 'new',
      show: false,
      title: 'New Account',
      disable: false
    }
  }

  mounted () {
    this.getAssets()
  }

  async getAssets () {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.query({
        query: getAccountAssets,
        variables: {
          accountId: +this.caseInfo.account.id,
          filter: {}
        }
      })
      this.assets = result.data.getAccountAssets.accountAssets
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  accountEditHandler () {
    this.accountDialog.show = true
  }

  propertyEditHandler () {
    this.propertyDialog.show = true
  }

  vehicleEditHandler () {
    this.vehicleDialog.show = true
  }

  @Emit('edit-policy')
  policyEditHandler () {
    // do nothing
  }

  @Emit('refresh')
  onSuccess () {
    this.getAssets()
  }

  routeToAccount () {
    if (!this.account) {
      return
    }
    this.$router.push({
      name: 'AccountDetailDetail',
      params: {
        id: this.account.id + ''
      }
    })
  }

  routeToAsset () {
    if (!this.asset) {
      return
    }

    if (this.property) {
      this.$router.push({
        name: 'AccountAssetPropertyDetail',
        params: {
          id: this.asset.id + ''
        }
      })
    } else {
      this.$router.push({
        name: 'AccountAssetVehicleDetail',
        params: {
          id: this.asset.id + ''
        }
      })
    }
  }

  routeToPolicy () {
    if (!this.policy) {
      return
    }
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: this.policy.id + ''
      }
    })
  }
}
